import { BaseParameterDto } from './base-parameter-dto';

export class AnnouncementsParametersDto extends BaseParameterDto {
  portalType: string = 'RP';

  override getQueryString(): string {
    return `?portalType=${this.portalType}&clearCache=${this.clearCache}`;
  }
}
